export default __webpack_public_path__ + "static/media/uncleFarmerJonny_FaceForWebsite.748ac338.jpg";